import React, { useMemo, useEffect, useState, useRef } from "react";
import TableContainer from "../../components/Common/TableContainer";
import { useNavigate } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  Card,
  CardBody,
  Container,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { Button } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import {
  FetchLocations,
  UpdateLocation,
  SearchCities,
} from "../../apis/PopularLocation";

const Location = () => {
  const [locations, setLocations] = useState([]);
  const [updateData, setUpdateData] = useState({
    id: "",
    name: { en: "", ar: "" },
    image: null,
    status: true,
  });

  // City autocomplete state for the edit modal
  const [cityInput, setCityInput] = useState("");
  const [cityOptions, setCityOptions] = useState([]);
  const [isCityDropdownOpen, setIsCityDropdownOpen] = useState(false);
  const [isCityLoading, setIsCityLoading] = useState(false);
  const [citySelectedFromDropdown, setCitySelectedFromDropdown] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dropdownRef = useRef(null);
  const debounceRef = useRef(null);

  const [modal_standard, setModal_standard] = useState(false);

  const tog_standard = () => setModal_standard(!modal_standard);
  const navigate = useNavigate();

  const fetchLocations = async () => {
    const response = await FetchLocations();
    setLocations(response.data.locations);
  };

  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    console.log("updateData", updateData);
  }, [updateData]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsCityDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!citySelectedFromDropdown) {
      toast.error("Please select a city from the suggestions");
      return;
    }

    const { id, name, image } = updateData;

    setIsSubmitting(true);
    try {
      const updatedLocation = await UpdateLocation(id, image, name);
      if (updatedLocation) {
        toast.success("Location Updated Successfully");
        setModal_standard(false);
        fetchLocations();
      } else {
        toast.error("Location Update Failed");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "City (English)",
        accessor: "name.en",
      },
      {
        Header: "City (Arabic)",
        accessor: "name.ar",
      },
      {
        Header: "Image",
        accessor: "locationImgUrl",
        Cell: ({ value }) => (
          <img
            src={value}
            alt="Location"
            style={{ width: "100px", height: "auto" }}
          />
        ),
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (value ? "Active" : "Inactive"),
      },
      {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => new Date(value).toLocaleDateString(),
      },
      {
        Header: "Action",
        accessor: "actions",
        Cell: ({ row }) => (
          <div>
            <Button
              color="primary"
              className="btn-icon"
              onClick={() => handleEditClick(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const handleEditClick = (location) => {
    setUpdateData({
      id: location._id,
      name: { en: location.name.en, ar: location.name.ar },
      image: location.locationImgUrl,
      status: location.status === "active",
    });
    setCityInput(location.name.en);
    setCitySelectedFromDropdown(true);
    // Pre-load city options
    setIsCityLoading(true);
    SearchCities(location.name.en)
      .then((hits) => setCityOptions(hits || []))
      .catch(() => {})
      .finally(() => setIsCityLoading(false));
    tog_standard();
  };

  const handleCityInputChange = (e) => {
    const value = e.target.value;
    setCityInput(value);
    setCitySelectedFromDropdown(false);
    setUpdateData((prev) => ({ ...prev, name: { en: value, ar: "" } }));

    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      setIsCityLoading(true);
      SearchCities(value)
        .then((hits) => setCityOptions(hits || []))
        .catch(() => {})
        .finally(() => setIsCityLoading(false));
    }, 300);
  };

  const handleCitySelect = (city) => {
    setUpdateData((prev) => ({
      ...prev,
      name: { en: city.nameEn, ar: city.nameAr },
    }));
    setCityInput(city.nameEn);
    setCitySelectedFromDropdown(true);
    setIsCityDropdownOpen(false);
  };

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Location", link: "#" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container>
          <Breadcrumbs title="DATA TABLES" breadcrumbItems={breadcrumbItems} />
          <Card>
            <CardBody>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  color="success"
                  className="waves-effect waves-light me-1"
                  onClick={() => navigate("/popular-location/add")}
                >
                  Add Location
                </Button>
              </div>
              <TableContainer
                columns={columns || []}
                data={locations || []}
                isPagination={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
              />
            </CardBody>
          </Card>

          {/* START: Modal EDIT  */}
          <Modal isOpen={modal_standard} toggle={tog_standard}>
            <ModalHeader toggle={() => setModal_standard(false)}>
              Edit Location
            </ModalHeader>
            <ModalBody>
              {/* City autocomplete */}
              <div
                className="mb-3"
                ref={dropdownRef}
                style={{ position: "relative" }}
              >
                <label className="form-label">City</label>
                <div style={{ position: "relative" }}>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search for a city..."
                    value={cityInput}
                    onChange={handleCityInputChange}
                    onFocus={() => setIsCityDropdownOpen(true)}
                    autoComplete="off"
                  />
                  {isCityLoading && (
                    <span
                      style={{
                        position: "absolute",
                        right: 10,
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    >
                      <Spinner size="sm" />
                    </span>
                  )}
                </div>
                {!citySelectedFromDropdown && cityInput && (
                  <small className="text-danger">
                    Please select a city from the list
                  </small>
                )}
                {isCityDropdownOpen && cityOptions.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      background: "#fff",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      maxHeight: 220,
                      overflowY: "auto",
                      zIndex: 1000,
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    }}
                  >
                    {cityOptions.map((city) => (
                      <div
                        key={city.cityId}
                        onMouseDown={() => handleCitySelect(city)}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          borderBottom: "1px solid #f0f0f0",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f5f5f5")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.background = "#fff")
                        }
                      >
                        <span>{city.nameEn}</span>
                        <span style={{ color: "#888", direction: "rtl" }}>
                          {city.nameAr}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Show selected city names */}
              {citySelectedFromDropdown && updateData.name.ar && (
                <div className="mb-3">
                  <small className="text-muted">
                    English: <strong>{updateData.name.en}</strong> &nbsp;|&nbsp;
                    Arabic: <strong>{updateData.name.ar}</strong>
                  </small>
                </div>
              )}

              <div className="mb-3">
                <img
                  src={updateData.image}
                  alt="Location"
                  style={{ width: "100px", height: "auto" }}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Location Image</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) =>
                    setUpdateData({
                      ...updateData,
                      image: e.target.files[0],
                    })
                  }
                />
              </div>

              <div className="form-check form-switch mb-3" dir="ltr">
                <h4 className="card-title">Status</h4>
                <Input
                  type="checkbox"
                  className="form-check-input"
                  checked={updateData.status}
                  onChange={() =>
                    setUpdateData({
                      ...updateData,
                      status: !updateData.status,
                    })
                  }
                  id="customSwitch1"
                />
                <Label className="form-check-label" htmlFor="customSwitch1">
                  {updateData.status ? "Active" : "Inactive"}
                </Label>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button
                type="button"
                onClick={tog_standard}
                color="light"
                className="waves-effect"
                disabled={isSubmitting}
              >
                Close
              </Button>
              <Button
                type="button"
                onClick={handleUpdate}
                color="primary"
                className="waves-effect waves-light"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <Spinner size="sm" className="me-1" /> Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </ModalFooter>
          </Modal>
          {/* END: Modal EDIT  */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Location;
